<template>
  <div class="home" v-if="$root.dataReady">
    <template>
      <template v-for="(block, index) in blocks">
        <component :is="block.acf_fc_layout" :key="index" :blockdata="block"></component>
      </template>
    </template>
  </div>
</template>

<script>
import BlockHomeHeading from "../components/BlockHomeHeading.vue";
import Block from "../components/Block.vue";
import BlockHomeSlider from "../components/BlockHomeSlider.vue";
import BlockHomeIdeas from "../components/BlockHomeIdeas.vue";
import BlockMap from "../components/BlockMap.vue";
import BlockMonkey from "../components/BlockMonkey.vue";
import BlockCmgGreenhouse from "../components/BlockCmgGreenhouse.vue";
import BlockCarousel from "../components/BlockCarousel.vue";

export default {
  name: "home-page",
  data() {
    return {
      blocks: null
    };
  },
  components: {
    BlockHomeHeading,
    Block,
    BlockHomeSlider,
    BlockHomeIdeas,
    BlockMap,
    BlockMonkey,
    BlockCmgGreenhouse,
    BlockCarousel
  },
  created: function() {
    this.$root.headeriswhite = true;
    this.$root.dataReady = false;
  },
  mounted: function() {
    this.fetchData();
  },
  methods: {
    homeImageLoader(data) {
      const homeBlock = data.filter(
        block => block.acf_fc_layout === "block-home-heading"
      )[0];
      let loadedImages = 0;
      homeBlock.slide.map(slide => {
        const image = new Image();
        image.src = slide.image.url;
        image.onload = () => {
          loadedImages++;
          if (loadedImages === homeBlock.slide.length) {
            this.$root.dataReady = true;
          }
        };
      });
    },
    fetchData: function() {
      var self = this;
      if(this.$route.query.preview_key) {
          if(this.$route.query.preview_type == 'post'){
            this.$router.replace({name: "post-preview", params: {id: this.$route.query.p, preview_key: this.$route.query.preview_key}, query: {}})
          } else if(this.$route.query.preview_type == 'jobs'){
              this.$router.replace({name: "post-preview-jobs", params: {id: this.$route.query.p, preview_key: this.$route.query.preview_key}, query: {}})
          } else if(this.$route.query.preview_type == 'cases_studies'){
            this.$router.replace({name: "post-preview-case-studies", params: {id: this.$route.query.p, preview_key: this.$route.query.preview_key}, query: {}})
          }
      } else {
        $.get(self.$root.apiUrl + "wp-json/wp/v2/pages?slug=home", function (
          response
        ) {
          self.blocks = response[0].acf.block_grid;
          self.setTitle(response[0].title.rendered);
          self.homeImageLoader(self.blocks);
        })
          .done(function () {
          })
          .fail(function () {
          });
      }
    },
    setTitle: function(title) {
        title = title.normalize('NFD').replace("&#038;", "&");
        document.title = title + " - Weber Shandwick";
    }
  }
};
</script>




// WEBPACK FOOTER //
// Home.vue?f8adaa34